/* v4.15.0: change the photo from the cart. Tap the design photo in the cart, then Change photo. The product page opens with the photo tool ready; the old line leaves the cart only after the new photo is added. */
(function () {
  var d = document, w = window;
  var CK = /^[A-Za-z0-9:_.-]{3,120}$/;
  var ctx = null;
  function ev(n) { try { if (typeof w.clarity === 'function') w.clarity('event', n); } catch (e) {} }

  /* A. cart: Change photo button inside the design viewer */
  var st = d.createElement('style');
  st.textContent = '.dc-czoom__chg{min-width:170px;background:#C2683F;border:1.5px solid #C2683F;color:#fff;border-radius:999px;padding:11px 18px;font-size:15px;font-weight:800;cursor:pointer}' +
    '.dc-czoom__chg[hidden],.dc-czoom__hint[hidden]{display:none}' +
    '.dc-czoom__hint{margin:0;max-width:330px;text-align:center;color:#E7DCCD;font-size:13px;line-height:1.4}' +
    '.dc-czoom.has-chg img{max-height:50vh}';
  d.head.appendChild(st);

  function lineCtx(zi) {
    var href = zi.getAttribute('href') || '';
    if (href.indexOf('/products/') !== 0) return null;
    var dr = zi.closest('.dc-cd__line');
    if (dr) {
      var kb = dr.querySelector('[data-key]'), qe = dr.querySelector('.dc-cd__q');
      var key = kb ? kb.getAttribute('data-key') : '';
      if (!CK.test(key)) return null;
      return { url: href, key: key, qty: parseInt(qe ? qe.textContent : '1', 10) || 1 };
    }
    var pg = zi.closest('.dc-line');
    if (pg) {
      var rm = pg.querySelector('.dc-line__remove'), qi = pg.querySelector('input[type=number]');
      var rh = rm ? (rm.getAttribute('href') || '') : '';
      var qn = parseInt(qi ? qi.value : '1', 10) || 1;
      var mk = /[?&]id=([^&]+)/.exec(rh), ml = /[?&]line=([0-9]+)/.exec(rh), pk = '';
      try { pk = mk ? decodeURIComponent(mk[1]) : ''; } catch (e) {}
      if (CK.test(pk)) return { url: href, key: pk, qty: qn };
      if (ml) return { url: href, line: parseInt(ml[1], 10), qty: qn };
      return null;
    }
    return null;
  }

  function go() {
    if (!ctx) return;
    var c = ctx, q = Math.max(1, Math.min(20, c.qty || 1));
    ev('cart_change_photo');
    var b = d.querySelector('.dc-czoom__chg');
    if (b) { b.disabled = true; b.textContent = 'Opening...'; }
    function nav(key) {
      var u = c.url + (c.url.indexOf('?') > -1 ? '&' : '?');
      location.href = key ? u + 'dc_added=photo&dc_change=' + encodeURIComponent(key) + '&dc_qty=' + q : c.url;
    }
    if (c.key) { nav(c.key); return; }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var it = j && j.items ? j.items[c.line - 1] : null;
      nav(it && CK.test(it.key) ? it.key : '');
    }).catch(function () { nav(''); });
  }

  function prep() {
    var z = d.querySelector('.dc-czoom');
    if (!z) return;
    var b = z.querySelector('.dc-czoom__chg'), h = z.querySelector('.dc-czoom__hint');
    if (!b) {
      var done = z.querySelector('.dc-czoom__done');
      b = d.createElement('button'); b.type = 'button'; b.className = 'dc-czoom__chg'; b.textContent = 'Change photo';
      h = d.createElement('p'); h.className = 'dc-czoom__hint';
      h.textContent = 'Want a different photo? Your current one stays in your cart until you add the new one.';
      z.insertBefore(b, done); z.insertBefore(h, done);
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(); });
    }
    b.disabled = false; b.textContent = 'Change photo';
    b.hidden = !ctx; h.hidden = !ctx;
    z.classList.toggle('has-chg', !!ctx);
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var zi = t.closest('.dc-cd__img, .dc-line__img');
    if (!zi) return;
    var im = zi.querySelector('img');
    if (!im || im.getAttribute('alt') !== 'Your design') return;
    ctx = lineCtx(zi);
    prep();
    setTimeout(prep, 0);
  });

  /* B. product page, arriving from the cart with ?dc_change=<line key> */
  var sp = null;
  try { sp = new URL(location.href).searchParams; } catch (e) {}
  var ck = sp ? (sp.get('dc_change') || '') : '';
  if (ck && CK.test(ck) && d.querySelector('[data-dc-product]')) {
    var q = parseInt(sp.get('dc_qty') || '1', 10);
    if (!(q > 0 && q <= 20)) q = 1;
    var replaced = false;
    ev('change_photo_arrive');

    /* the new photo goes in first; only then does the old line leave the cart */
    var of = w.fetch;
    w.fetch = function (u, o) {
      var p = of.apply(this, arguments);
      try {
        var us = typeof u === 'string' ? u : ((u && u.url) || '');
        if (!replaced && o && o.method === 'POST' && us.indexOf('/cart/add.js') > -1 && o.body instanceof FormData) {
          return p.then(function (r) {
            if (!r || !r.ok) return r;
            replaced = true;
            return of.call(w, '/cart/change.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: ck, quantity: 0 })
            }).then(function () { ev('change_photo_done'); return r; }, function () { return r; });
          });
        }
      } catch (err) {}
      return p;
    };

    var root = d.querySelector('[data-dc-product]');
    var qi = root.querySelector('input[name=quantity]');
    if (qi) qi.value = q;
    Array.prototype.slice.call(root.querySelectorAll('.dc-pz-added')).forEach(function (n) { n.parentNode.removeChild(n); });
    var app = root.querySelector('.dc-pdp__app'), hint = root.querySelector('[data-dc-pzhint]');
    var anchor = hint && app && hint.parentNode === app.parentNode ? hint : app;
    if (anchor && anchor.parentNode) {
      var note = d.createElement('p');
      note.className = 'dc-pz-added';
      var sg = d.createElement('strong'); sg.textContent = 'Changing your photo.';
      var ka = d.createElement('a'); ka.href = '/cart'; ka.setAttribute('data-dc-cart-open', ''); ka.textContent = 'Keep my current photo';
      note.appendChild(sg);
      note.appendChild(d.createTextNode(' Pick a new one below. Your current photo stays in your cart until the new one is added. '));
      note.appendChild(ka);
      anchor.parentNode.insertBefore(note, anchor);
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var b = root.querySelector('.personalize-button');
      if (b) {
        clearInterval(iv);
        try { b.scrollIntoView({ block: 'center' }); } catch (z) {}
        b.click();
        ev('change_photo_editor');
      } else if (tries > 40) { clearInterval(iv); }
    }, 300);
  }
})();
